import { render, staticRenderFns } from "./CompareRateSummary.vue?vue&type=template&id=353ecda0"
import script from "./CompareRateSummary.vue?vue&type=script&lang=js"
export * from "./CompareRateSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports